module.exports = __webpack_public_path__ + "static/img/yeswecan0014.ce582d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0014.png
// module id = 589
// module chunks = 1